import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const RadioButton = ({
    label,
    value,
    checked,
    onChange,
    isTextBlack,
    className,
}) => {
    const isChecked = checked === value

    const toggleCheck = () => {
        onChange(value)
    }

    return (
        <div
            className={clsx(
                'flex flex-row items-center justify-start min-w-min',
                className,
            )}
        >
            <span
                onClick={toggleCheck}
                className={clsx(
                    'w-4 h-4 ring-inset rounded-full ring-white ring-4 border cursor-pointer',
                    isChecked
                        ? 'border-yellow bg-yellow'
                        : 'border-grayLines bg-white',
                )}
            />
            {label && (
                <label className="text-textDarkGray text-sm font-medium ml-2">
                    <span
                        className={clsx(
                            'font-medium text-sm',
                            isTextBlack
                                ? 'text-textDarkerGray'
                                : 'text-textDarkGray',
                        )}
                    >
                        {label}
                    </span>
                </label>
            )}
        </div>
    )
}

RadioButton.propTypes = {
    name: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
        PropTypes.any,
    ]),
    checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.any]),
    onChange: PropTypes.oneOfType([PropTypes.func, PropTypes.any]),
    isTextBlack: PropTypes.oneOfType([PropTypes.bool, PropTypes.any]),
    className: PropTypes.string,
}

export default RadioButton
